import { render, staticRenderFns } from "./scanQR-BigBangBoom.html?vue&type=template&id=ca9acb4c&scoped=true&"
import script from "./scanQR-vn.vue?vue&type=script&lang=js&"
export * from "./scanQR-vn.vue?vue&type=script&lang=js&"
import style0 from "./scanQR-vn.vue?vue&type=style&index=0&id=ca9acb4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9acb4c",
  null
  
)

export default component.exports